import { translateFormatter } from '@/core/localization/translate';
import { translate } from '@/domains/core/localization/translate';
export const {
  proButtonTitle
} = translate({
  "proButtonTitle": "Are you a Pro?"
});
export const proOfferText = translateFormatter<{
  amount: string;
}>([{
  "type": 0,
  "value": "Get "
}, {
  "type": 1,
  "value": "amount"
}, {
  "type": 0,
  "value": " off"
}], undefined, undefined, "en");